"use client";
import { useEffect } from "react";
import Script from "next/script";

declare global {
  interface Window {
    Intercom: any;
  }
}

const IntercomChat = () => {
  const appId = process.env.NEXT_PUBLIC_INTERCOM_APP_ID;
  useEffect(() => {
    if (process.env.NODE_ENV !== "production" || !appId) {
      return;
    }
  }, [appId]);

  useEffect(() => {
    if (process.env.NODE_ENV === "production" && appId) {
      // Queue calls until widget script is downloaded.
      window.Intercom =
        window.Intercom ||
        function () {
          (window.Intercom.q = window.Intercom.q || []).push(arguments);
        };

      window.Intercom("boot", {
        api_base: "https://api-iam.intercom.io",
        app_id: appId,
      });

      return () => {
        window.Intercom("shutdown");
      };
    }
  }, [appId]);

  if (process.env.NODE_ENV !== "production" || !appId) {
    return null;
  }

  return (
    <Script
      id="intercom-widget"
      src={`https://widget.intercom.io/widget/${appId}`}
      strategy="afterInteractive"
    />
  );
};

export default IntercomChat;
